import { Stack } from '@mui/material'

import { preview } from '@/components/form/preview'
import { Field } from './Field'

import type { ExecutionEventsFormValues } from '../../../typings'
import { useTexts } from '../useTexts'

interface Props {
  value: ExecutionEventsFormValues['customFields']
  onChange: (key: string, value: string) => void
  testId?: string
  fieldDisabled?: boolean
}

export function CustomFields(props: Props) {
  const { value, onChange, testId, fieldDisabled } = props
  const texts = useTexts()

  const entries = Object.entries(value)

  return (
    <Stack direction="column" spacing={2} data-testid={testId}>
      {entries.map(([label, customField]) => {
        if (customField.disabled) {
          return (
            <preview.Field label={label} testId={`${testId}-${label}`}>
              {texts.undeclared}
            </preview.Field>
          )
        }
        return (
          <Field
            key={label}
            label={label}
            value={customField.value}
            onChange={onChange}
            testId={`${testId}-${label}`}
            disabled={fieldDisabled}
          />
        )
      })}
    </Stack>
  )
}
